import shellHttpClient from '@/shells/api/shellHttpClient';

export class ModernAccountRepository {
  constructor(client = shellHttpClient) {
    this.client = client;
  }

  async logout() {
    await this.client.get('/api/v1/users/user/log-out');
  }

  async getChatDisplaySetting() {
    const response = await this.client.get('/adminmenu/zopim-display-setting');
    return response.data && response.data.success ? Number(response.data.value) : 0;
  }
}

export const modernAccountRepository = new ModernAccountRepository();
